export enum TipoPendencia {
    COBRANCA = 'Cobranca',
    EXIGIBILIDADE_SUSPENSA = 'Exigibilidade'
}